import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from "../shared/loader/loader.service";
import { AuthService } from "../core/auth/auth.service";
import { StorageService } from '../Service/storage.service';

@Component({
    selector: 'kt-session-out',
    templateUrl: './session-out.component.html',
    styleUrls: ['./session-out.component.scss'],
    standalone: false
})
export class SessionOutComponent implements OnInit {
  close: boolean = false;
  loading: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: { onExtend: Function, onClose: Function },
    private toasterService: ToastrService,
    public LoaderService: LoaderService,
    private dialogRef: MatDialogRef<SessionOutComponent>,
    private readonly authService: AuthService, private readonly storageService: StorageService) { }
  ngOnInit() {
  }
  onExtend() {
    const userId = this.storageService.getItem('userId');
    this.LoaderService.show();
    this.loading = true;
    this.authService.ResetToken(userId).subscribe(
      (response) => {
        this.storageService.setItem("token", response["Data"]);
        this.LoaderService.hide();
        this.toasterService.success("Session extended");
        this.data.onExtend?.();
        this.dialogRef.close();
      },
      () => {
        this.LoaderService.hide();
        setTimeout(() => {
          this.toasterService.error("Something went wrong.");
          this.dialogRef.close();
        }, 200);
      }
    );
  }

  onClose() {
    this.data.onClose?.();
    this.dialogRef.close();
  }
}


